import { CosmosChain, CronosChain, EthChainId, Network } from '@types';
import staticConfig from '@config/static-config';

const { explorers } = staticConfig;

function useGetSrcChainExplorerUrl(): (
  network: Network,
  chain: CronosChain | EthChainId | CosmosChain
) => string {
  function getExplorerUrl(
    network: Network,
    chain: CronosChain | EthChainId | CosmosChain
  ): string {
    return explorers[network]?.[chain] || '';
  }

  return getExplorerUrl;
}

export default useGetSrcChainExplorerUrl;
